import { render, staticRenderFns } from "./template.vue?vue&type=template&id=a1e875fc&scoped=true&"
import script from "@/Components/Global/StatusBar/component.ts?vue&type=script&lang=ts&"
export * from "@/Components/Global/StatusBar/component.ts?vue&type=script&lang=ts&"
import style0 from "@/Components/Global/StatusBar/style.scss?vue&type=style&index=0&id=a1e875fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e875fc",
  null
  
)

export default component.exports